import { TREE_ITEM_TYPES, INPUT_TYPES } from "../constants/AppEnums";

export const initialState = {
  user: {
    userId: '',
    username: '',
    email:'',
    memberships: [],
    primaryOrg: {}
    
  },
  modelRun: {
    selectedModelRun:{},
    modelRuns:[],
    generateRunStatus: "NONE",
    nextTokens: [],
    isLoading: false,
    uploadProgress: {},
    completedUploads: [],
    cancelTokens: {}

  },
  modeler: {
    activeModeler: {
      error: false,
      errorMessage: '',      
    },
    activeModelerId: -1,
    modelersList: [],
    isLoading: false,
    searchError: false,
    searchErrorMessage: '',  
    activeModelRunId: null,      
  },
  template: {
    activeTemplate: {
      published: false,
      templateId: -1,
      selectedGroup: {},
      selectedFolder:{},
      parameterGroups: [],
      folders: [],
      isLoading: false,
      error: false,
      errorMessage: '',
      created: false,
    },
    templatesList: [],
    isLoading: false,
    searchError: false,
    searchErrorMessage: '',    
    error: false,
  },
};
